import { render, staticRenderFns } from "./RegRoadentsAdd.vue?vue&type=template&id=59ebc810"
import script from "./RegRoadentsAdd.vue?vue&type=script&lang=js"
export * from "./RegRoadentsAdd.vue?vue&type=script&lang=js"
import style0 from "./RegRoadentsAdd.vue?vue&type=style&index=0&id=59ebc810&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports